import PropTypes from "prop-types";
import React from "react";

import {
  Avatar,
  ArticleDonationBanner,
  Person,
  Typography
} from "@theconversation/ui";

/**
 * The `EndOfArticle` component represents promos that are rendered at the
 * bottom of an article.
 */
function EndOfArticle({ title, body, person, donateText, onClick }) {
  return (
    <ArticleDonationBanner donateText={donateText} onClick={onClick}>
      <Typography variant="h6" gutterBottom>{title}</Typography>
      <Typography variant="body1" paragraph>{body}</Typography>
      <div key="attribution">
        <Typography gutterBottom>
          <Person name={person.name} caption={person.caption} />
        </Typography>
        { person.avatar && <Avatar size={48} src={person.avatar} /> }
      </div>
    </ArticleDonationBanner>
  );
}

EndOfArticle.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  person: PropTypes.shape({
    avatar: PropTypes.string,
    caption: PropTypes.string,
    name: PropTypes.string.isRequired,
  }).isRequired,
  donateText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default EndOfArticle;
